export const selectSuccess = (state) => state.oauth.success;
export const selectError = (state) => state.oauth.error;
export const selectLoading = (state) => state.oauth.loading;
